module.exports = __webpack_public_path__ + "img/alexis-nihon.46ca2c83.webp";